import { render, staticRenderFns } from "./Patent-application.vue?vue&type=template&id=3017b8f4&scoped=true&"
import script from "./Patent-application.vue?vue&type=script&lang=js&"
export * from "./Patent-application.vue?vue&type=script&lang=js&"
import style0 from "./Patent-application.vue?vue&type=style&index=0&id=3017b8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3017b8f4",
  null
  
)

export default component.exports